// Tiny wrapper around window.sessionStorage. Used by Pinia stores and views that want to
// preserve "current context" state — filter inputs, current page, etc. — across in-tab
// navigation and reloads, but discard it when the operator closes the tab. localStorage is
// reserved for cross-session UI preferences (theme, expand/collapse state, splitter
// dimensions, table page sizes).
//
// Failures are silent: sessionStorage can be disabled (private mode in some browsers) or out
// of quota; persistence is best-effort and the fallback to defaults is acceptable.

export function readSession<T>(key: string, fallback: T): T {
  try {
    const raw = window.sessionStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function writeSession(key: string, value: unknown): void {
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // sessionStorage disabled / quota — silently drop. Persistence is best-effort.
  }
}
